<template>
    <div>
        <ul class="metadata-dock-open-icon">
            <li v-on:click="showMetadataDock()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  fill="currentColor" v-if="!getIsMetadataDockVisible()" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" v-if="getIsMetadataDockVisible()"  fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                </svg>
            <li :key="menu.label" v-for="menu in getRegisteredFloatingMenu()" v-on:click="getEventHandler('onClick',menu.onEvents)"  v-html="menu.iconSvgCallback(menu.label)" style="margin-top:12px;">
            </li>
        </ul>
    </div>
</template>
<script>

import {mapGetters,mapMutations,mapActions} from "vuex"

export default {
    data(){
        return{
            floatingMenus:["chat"],
        }
    },
    methods:{
        showMetadataDock(){
            let metadataDock = this.getIsMetadataDockVisible()
            this.setMetadataDockState(!metadataDock)
        },
        setUpFloatingMenus(){
            // for (let menu of floatingMenus) {
            //     if (menu == "metadata dock"){
            //             let metadataDockEvents = [{
            //                 "event_name": "onClick",
            //                 "event_handler": this.showMetadataDock,
            //                 "handler_args":[]
            //             }]
            //             let metadata = new FloatingMenu("metadata", "metadata", "Metadata", null,metadataDockEvents)
            //             metadata.register()
            //     }
            // }
        },
        getEventHandler(eventname,supportedEvents){
          let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
          if(event.length != 0){
            return event[0]["event_handler"]();
          }
        },
        registorFloatingMenu(menu){
            this.registerFloatingMenu(menu)
        },
    //     registorInstalledPlugins(){
    //     this.getInstalledPluginsFromServer().then((data) => {
    //       let externalPlugins = []
    //       if (data.statusCode == 200){
    //         externalPlugins = data.plugins
    //       }
    //       for (let plugin of externalPlugins) {
    //         try {
    //           this.registerDamPlugin({plugin: plugin,                                             // eslint-disable-line no-undef  
    //             jsFileUrl:`${window.location.origin}/damplugins${plugin.web_hook_path}` , 
    //             damInterface:{
    //                 floatingmenuRegistrator: this.registorFloatingMenu
    //               }
    //           }) 
    //         } catch (error) {
    //           console.error(error)
    //         }
    //       }
    //     });
    //   },
      ...mapGetters("users", ["getIsMetadataDockVisible"]),
      ...mapActions("pluginRepo", ["getInstalledPluginsFromServer"]),
      ...mapGetters("registry",["getRegisteredFloatingMenu"]),
      ...mapMutations("registry",["registerDamPlugin","registerFloatingMenu","unSetFloatingMenu"]),
      ...mapMutations("users",["setMetadataDockState"]),
    },
    emits:["showMetadataDockPanel"],
    mounted(){
        this.setUpFloatingMenus(this.floatingMenus);
    },
}
</script>

<style scoped lang="scss">
    ul{
        list-style-type: none;
        padding:0px;
        position: absolute;
        bottom:10%;
        inset-inline-end:0px;
        li{
            height:30px;
            width:30px;
            border: 1px solid #848484;
            background: #1b1b1b;
            border-top-left-radius: 9px;
            border-bottom-left-radius: 9px;
            padding: 0px;
            border-inline-end: none !important;
            svg{
                margin-top: 3px;
                color:#eee;
            }
        }
    }
</style>